import { store } from "@/store";
import { fabric } from "fabric";
import { cloneProxy } from "../utils";

import MediaService from "@/services/media";

export const Context = {
  canvas: null,
};

const CanvasService = {
  fontSize: 24,
  scale: 0.9,

  drawSelectedModel() {
    const center = Context.canvas.getCenter();
    Context.canvas.setBackgroundImage(
      store.getters["product/selectedModelColorUrl"],
      (data) => {
        Context.canvas.backgroundImage.scaleX =
          (Context.canvas.getWidth() / data.width) * this.scale;
        Context.canvas.backgroundImage.scaleY =
          (Context.canvas.getHeight() / data.height) * this.scale;
        return Context.canvas.renderAll();
      },
      {
        backgroundImageOpacity: 1,
        backgroundImageStretch: false,
        top: center.top,
        left: center.left,
        originX: "center",
        originY: "center",
      }
    );
    const designArea = new fabric.Rect({
      left: center.left,
      top: center.top,
      originX: "center",
      originY: "center",
      width: 250,
      height: 200,
      fill: "#5c92f347",
      stroke: "#5c92f3",
      strokeWidth: 1,
      selectable: false,
    });
    Context.canvas.add(designArea);
    Context.canvas.renderAll();
  },

  addTextLayer(text = "Text") {
    let center = Context.canvas.getCenter();
    let textLayer = new fabric.Text(text, {
      layerId: Date.now(),
      layerType: "text",
      mode: store.state.canvas.mode,
      fill: "#000000",
      fontSize: this.fontSize,
      fontFamily: "Roboto",
      scaleX: 1,
      scaleY: 1,
      top: center.top,
      left: center.left,
      originX: "center",
      originY: "center",
      borderColor: "#fbd444",
      cornerColor: "#fbd444",
      strokeWidth: 20,
      cornerSize: 15,
      transparentCorners: false,
      globalCompositeOperation: "source-atop",
      _controlsVisibility: {
        mt: false,
        mb: false,
        ml: false,
        mr: false,
      },
    });
    this.clipToDesignArea(textLayer);
    Context.canvas.add(textLayer);
    Context.canvas.setActiveObject(textLayer);
    Context.canvas.renderAll();
  },

  addImageLayer(url) {
    fabric.Image.fromURL(url, (imageLayer) => {
      imageLayer.set({
        layerId: Date.now(),
        layerType: "image",
        mode: store.state.canvas.mode,
        borderColor: "#fbd444",
        cornerColor: "#fbd444",
        originX: "center",
        originY: "center",
        strokeWidth: 20,
        cornerSize: 15,
        transparentCorners: false,
        _controlsVisibility: {
          mt: false,
          mb: false,
          ml: false,
          mr: false,
        },
      });
      var imageWidth = Context.canvas.getWidth() * 0.35;
      imageLayer.scaleToWidth(imageWidth);
      this.clipToDesignArea(imageLayer);

      Context.canvas.add(imageLayer);
      imageLayer.setCoords();
      Context.canvas.centerObject(imageLayer);
      Context.canvas.setActiveObject(imageLayer);
      Context.canvas.renderAll();
    });
  },
  clipToDesignArea(obj) {
    obj.set({
      clipPath: new fabric.Rect({
        width: 250,
        height: 200,
        left: Context.canvas.width / 2, // center horizontally
        top: Context.canvas.height / 2,
        originX: "center",
        originY: "center",
        absolutePositioned: true,
      }),
    });
  },
  changeMode() {
    Context.canvas.getObjects().forEach((object) => {
      object.visible = object.mode != store.state.canvas.mode ? false : true;
    });
    let center = Context.canvas.getCenter();
    console.log(center);

    const designArea = new fabric.Rect({
      left: center.left,
      top: center.top,
      originX: "center",
      originY: "center",
      width: 250,
      height: 200,
      fill: "#5c92f347",
      stroke: "#5c92f3",
      strokeWidth: 1,
      selectable: false,
    });
    Context.canvas.add(designArea);
    Context.canvas.setActiveObject(designArea);

    Context.canvas.discardActiveObject();
    Context.canvas.renderAll();
  },

  selectLayer(layer, callback = () => {}) {
    Context.canvas.getObjects().forEach((object) => {
      if (object.layerId == layer.layerId) {
        Context.canvas.renderAll();
        callback(object);
      }
    });
  },

  removeLayer(layer) {
    Context.canvas.getObjects().forEach((object) => {
      if (object.layerId == layer.layerId) {
        Context.canvas.remove(object);
        Context.canvas.renderAll();
      }
    });
  },

  duplicateLayer(layer) {
    Context.canvas.getObjects().forEach((object) => {
      if (object.layerId == layer.layerId) {
        const clone = cloneProxy(object);
        clone.set({
          layerId: Date.now(),
          left: clone.left + 10,
          top: clone.top + 10,
        });
        Context.canvas.add(clone);
        Context.canvas.renderAll();
      }
    });
  },

  filter(name) {
    return {
      get() {
        return !!this.selectedLayer.filters.filter((f) => f.type == name)
          .length;
      },
      set(value) {
        if (value) {
          this.selectedLayer.filters.push(new fabric.Image.filters[name]());
        } else {
          this.selectedLayer.filters = this.selectedLayer.filters.filter(
            (f) => f.type != name
          );
        }
        this.selectedLayer.applyFilters();
      },
    };
  },

  toJSON() {
    return Context.canvas.toJSON([
      "mode",
      "layerId",
      "layerType",
      "_controlsVisibility",
    ]);
  },

  loadFromJSON(data, callback = () => {}) {
    Context.canvas.loadFromJSON(data, callback);
  },

  deleteAllLayers() {
    Context.canvas.getObjects().forEach((object) => {
      Context.canvas.remove(object);
    });
  },

  async takeVirtualCapture(mode) {
    let canvas = new fabric.Canvas(null, {
      width: Context.canvas.width,
      height: Context.canvas.height,
    });

    return new Promise((resolve) => {
      canvas.loadFromJSON(this.toJSON(), () => {
        canvas.getObjects().forEach((object) => {
          object.visible = object.mode != mode ? false : true;
        });

        const center = canvas.getCenter();

        canvas.setBackgroundImage(
          store.state.product.selectedModelColor[mode].url,
          (data) => {
            canvas.backgroundImage.scaleX =
              (canvas.getWidth() / data.width) * this.scale;
            canvas.backgroundImage.scaleY =
              (canvas.getHeight() / data.height) * this.scale;

            canvas
              .renderAll()
              .getElement()
              .toBlob(
                (blob) => {
                  resolve(blob);
                },
                "image/png",
                1
              );
          },
          {
            backgroundImageOpacity: 1,
            backgroundImageStretch: false,
            scaleX: 0.35,
            scaleY: 0.35,
            top: center.top,
            left: center.left,
            originX: "center",
            originY: "center",
            crossOrigin: "anonymous",
          }
        );
      });
    });
  },
  blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // Only get the base64 part
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  },
  async capture() {
    let front, back;

    let frontBlob = await this.takeVirtualCapture("front");
    let frontBase64 = await this.blobToBase64(frontBlob);
    front = await MediaService.uploadbase64(frontBase64);

    console.log(store.state.product.selectedModelColor.back);

    if (store.state.product.selectedModelColor.back) {
      let backBlob = await this.takeVirtualCapture("back");
      let backBase64 = await this.blobToBase64(backBlob);
      back = await MediaService.uploadbase64(backBase64);
    }

    return {
      front,
      back,
    };
  },
};

export default CanvasService;
